module.exports = __webpack_public_path__ + "img/more-banner.1fa48282.png";